export interface TsAppVersion {
    version: string;
    name: string;
    description?: string;
    versionLong?: string;
    versionDate: string;
    gitCommitHash?: string;
    gitCommitDate?: string;
    gitTag?: string;
};
export const versions: TsAppVersion = {
    version: '1.55.4',
    name: 'orga-app-desktop-client',
    versionDate: '2026-10-31T17:12:02.346Z',
    description: 'ORGArena ORGA App',
    gitCommitHash: 'g9c815915',
    gitCommitDate: '2026-10-31T17:05:01.000Z',
    versionLong: '1.55.4-g9c815915',
    gitTag: 'v1.55.4',
};
export default versions;
